// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation CreateStripeCheckoutSessionMutation($input: CreateStripeCheckoutSessionInput!) {
    createStripeCheckoutSession(input: $input) {
      sessionUrl
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
